{
  "name": "@primer/react",
  "version": "35.30.0",
  "description": "An implementation of GitHub's Primer Design System using React",
  "main": "lib/index.js",
  "module": "lib-esm/index.js",
  "exports": {
    ".": {
      "import": "./lib-esm/index.js",
      "require": "./lib/index.js"
    },
    "./experimental": {
      "import": "./lib-esm/experimental/index.js",
      "require": "./lib/experimental/index.js"
    },
    "./drafts": {
      "import": "./lib-esm/drafts/index.js",
      "require": "./lib/drafts/index.js"
    },
    "./deprecated": {
      "import": "./lib-esm/deprecated/index.js",
      "require": "./lib/deprecated/index.js"
    },
    "./lib-esm/*": {
      "import": [
        "./lib-esm/*.js",
        "./lib-esm/*/index.js"
      ],
      "require": [
        "./lib/*.js",
        "./lib/*/index.js"
      ]
    },
    "./lib-esm/internal/*": null
  },
  "typings": "lib/index.d.ts",
  "sideEffects": false,
  "scripts": {
    "setup": "./script/setup",
    "build": "./script/build",
    "clean": "rimraf dist lib lib-esm css",
    "format": "prettier --cache --write '**/*.{js,css,md,mdx,ts,tsx,yml}'",
    "format:diff": "prettier --cache --list-different '**/*.{js,css,md,mdx,ts,tsx,yml}'",
    "start": "concurrently npm:start:*",
    "start:docs": "cd docs && npm run develop",
    "start:storybook": "STORYBOOK=true storybook dev -p 6006",
    "build:storybook": "script/build-storybook",
    "build:docs": "NODE_OPTIONS=--openssl-legacy-provider script/build-docs",
    "build:docs:preview": "NODE_OPTIONS=--openssl-legacy-provider script/build-docs preview",
    "build:storybook:visual-testing": "storybook build",
    "build:components.json": "ts-node script/components-json/build",
    "install:docs": "(cd docs && npm install --legacy-peer-deps)",
    "lint": "eslint '**/*.{js,ts,tsx,md,mdx}' --max-warnings=0",
    "lint:fix": "npm run lint -- --fix",
    "lint:md": "markdownlint-cli2 \"**/*.{md,mdx}\" \"!.github\" \"!.changeset\" \"!node_modules\" \"!CHANGELOG.md\"",
    "test": "jest",
    "test:storybook": "test-storybook",
    "test:update": "npm run test -- --updateSnapshot",
    "test:watch": "npm run test -- --watch",
    "test:coverage": "npm run test -- --coverage",
    "test:type-check": "tsc --noEmit",
    "release": "npm run build && changeset publish",
    "size": "size-limit",
    "prepare": "husky install"
  },
  "repository": "primer/react",
  "keywords": [
    "react",
    "components",
    "library",
    "design-system"
  ],
  "files": [
    "codemods",
    "dist",
    "lib",
    "lib/node_modules",
    "lib-esm",
    "css",
    "index.d.ts",
    "deprecated/package.json",
    "drafts/package.json",
    "experimental/package.json",
    "!lib/__tests__",
    "!lib/stories",
    "!lib-esm/__tests__",
    "!lib-esm/stories",
    "generated"
  ],
  "author": "GitHub, Inc.",
  "license": "MIT",
  "engines": {
    "node": ">=12",
    "npm": ">=7"
  },
  "dependencies": {
    "@github/combobox-nav": "^2.1.5",
    "@github/markdown-toolbar-element": "^2.1.0",
    "@github/paste-markdown": "^1.4.0",
    "@github/relative-time-element": "^4.1.2",
    "@lit-labs/react": "^1.1.1",
    "@primer/behaviors": "^1.3.4",
    "@primer/octicons-react": "^19.7.0",
    "@primer/primitives": "^7.11.11",
    "@react-aria/ssr": "^3.5.0",
    "@styled-system/css": "^5.1.5",
    "@styled-system/props": "^5.1.5",
    "@styled-system/theme-get": "^5.1.2",
    "@types/react-is": "^18.2.1",
    "@types/styled-components": "^5.1.11",
    "@types/styled-system": "^5.1.12",
    "@types/styled-system__css": "^5.0.16",
    "@types/styled-system__theme-get": "^5.0.1",
    "clsx": "^1.2.1",
    "color2k": "^2.0.0",
    "deepmerge": "^4.2.2",
    "focus-visible": "^5.2.0",
    "fzy.js": "^0.4.1",
    "history": "^5.0.0",
    "lodash.isempty": "^4.4.0",
    "lodash.isobject": "^3.0.2",
    "react-intersection-observer": "^9.4.3",
    "react-is": "^18.2.0",
    "react-markdown": "8.0.7",
    "styled-system": "^5.1.5"
  },
  "devDependencies": {
    "@actions/core": "1.10.0",
    "@babel/cli": "7.22.10",
    "@babel/core": "7.22.5",
    "@babel/eslint-parser": "7.21.3",
    "@babel/plugin-proposal-nullish-coalescing-operator": "7.18.6",
    "@babel/plugin-proposal-optional-chaining": "7.21.0",
    "@babel/plugin-transform-modules-commonjs": "7.22.5",
    "@babel/preset-react": "7.22.15",
    "@babel/preset-typescript": "7.22.15",
    "@changesets/changelog-github": "0.4.8",
    "@github/markdownlint-github": "^0.3.0",
    "@github/prettier-config": "0.0.6",
    "@playwright/test": "1.37.0",
    "@prettier/sync": "0.3.0",
    "@primer/css": "^21.0.1",
    "@rollup/plugin-babel": "6.0.3",
    "@rollup/plugin-commonjs": "25.0.4",
    "@rollup/plugin-node-resolve": "15.1.0",
    "@rollup/plugin-replace": "5.0.2",
    "@rollup/plugin-terser": "0.4.3",
    "@rollup/plugin-typescript": "11.1.0",
    "@rollup/plugin-virtual": "3.0.1",
    "@size-limit/preset-big-lib": "8.2.6",
    "@storybook/addon-a11y": "7.1.0",
    "@storybook/addon-actions": "7.1.0",
    "@storybook/addon-essentials": "7.1.0",
    "@storybook/addon-interactions": "7.1.0",
    "@storybook/addon-links": "7.1.0",
    "@storybook/addon-storysource": "7.1.0",
    "@storybook/addon-styling": "1.3.4",
    "@storybook/csf": "0.1.1",
    "@storybook/jest": "0.1.0",
    "@storybook/react": "7.1.0",
    "@storybook/react-webpack5": "7.1.0",
    "@storybook/test-runner": "0.11.0",
    "@storybook/testing-library": "0.2.0",
    "@storybook/theming": "7.1.0",
    "@testing-library/dom": "9.3.1",
    "@testing-library/jest-dom": "5.17.0",
    "@testing-library/react": "14.0.0",
    "@testing-library/react-hooks": "7.0.2",
    "@testing-library/user-event": "^14.3.0",
    "@types/jest": "29.5.3",
    "@types/jest-axe": "3.5.5",
    "@types/lodash.groupby": "4.6.7",
    "@types/lodash.isempty": "4.4.7",
    "@types/lodash.isobject": "3.0.7",
    "@types/lodash.keyby": "4.6.7",
    "@types/node": "18.16.19",
    "@types/react": "18.2.21",
    "@types/react-dom": "18.2.6",
    "@typescript-eslint/eslint-plugin": "5.59.6",
    "@typescript-eslint/parser": "5.62.0",
    "ajv": "8.12.0",
    "axe-core": "4.7.0",
    "babel-core": "7.0.0-bridge.0",
    "babel-loader": "^9.1.0",
    "babel-plugin-add-react-displayname": "0.0.5",
    "babel-plugin-dev-expression": "0.2.3",
    "babel-plugin-macros": "3.1.0",
    "babel-plugin-open-source": "1.3.4",
    "babel-plugin-styled-components": "2.1.4",
    "babel-plugin-transform-replace-expressions": "0.2.0",
    "babel-polyfill": "6.26.0",
    "change-case": "4.1.2",
    "concurrently": "8.0.1",
    "copyfiles": "2.4.1",
    "cross-env": "7.0.3",
    "eslint": "8.40.0",
    "eslint-import-resolver-typescript": "3.6.0",
    "eslint-plugin-github": "4.8.0",
    "eslint-plugin-jest": "27.2.1",
    "eslint-plugin-jsx-a11y": "6.7.1",
    "eslint-plugin-mdx": "2.2.0",
    "eslint-plugin-playwright": "0.15.1",
    "eslint-plugin-prettier": "5.0.0",
    "eslint-plugin-primer-react": "4.0.1",
    "eslint-plugin-react": "7.32.2",
    "eslint-plugin-react-hooks": "4.6.0",
    "eslint-plugin-ssr-friendly": "1.2.0",
    "eslint-plugin-storybook": "0.6.13",
    "eslint-plugin-testing-library": "5.11.0",
    "fast-glob": "3.2.12",
    "filesize": "10.0.6",
    "front-matter": "4.0.2",
    "gzip-size": "6.0.0",
    "husky": "8.0.3",
    "jest": "29.6.1",
    "jest-axe": "7.0.1",
    "jest-css-modules": "2.1.0",
    "jest-environment-jsdom": "29.4.3",
    "jest-fail-on-console": "3.1.1",
    "jest-matchmedia-mock": "1.1.0",
    "jest-styled-components": "6.3.4",
    "jest-watch-typeahead": "2.2.2",
    "jscodeshift": "0.14.0",
    "lint-staged": "13.2.2",
    "lodash.groupby": "4.6.0",
    "lodash.keyby": "4.6.0",
    "markdownlint-cli2": "^0.7.1",
    "markdownlint-cli2-formatter-pretty": "0.0.3",
    "mdast-util-from-markdown": "1.3.0",
    "mdast-util-frontmatter": "1.0.1",
    "mdast-util-mdx": "3.0.0",
    "mdast-util-to-string": "4.0.0",
    "micromark-extension-frontmatter": "2.0.0",
    "micromark-extension-mdxjs": "2.0.0",
    "postcss-custom-properties-fallback": "1.0.2",
    "postcss-preset-env": "9.0.0",
    "prettier": "3.0.1",
    "primer-changesets-cli": "2.2.1",
    "react": "18.2.0",
    "react-dnd": "14.0.4",
    "react-dnd-html5-backend": "14.0.2",
    "react-dom": "18.2.0",
    "react-test-renderer": "18.2.0",
    "recast": "0.22.0",
    "rimraf": "4.1.2",
    "rollup": "3.20.2",
    "rollup-plugin-postcss": "4.0.2",
    "rollup-plugin-visualizer": "5.9.2",
    "semver": "7.5.0",
    "size-limit": "8.2.4",
    "storybook": "7.1.0",
    "storybook-addon-turbo-build": "2.0.1",
    "styled-components": "4.4.1",
    "terser": "5.17.6",
    "ts-node": "10.9.1",
    "ts-toolbelt": "9.6.0",
    "typescript": "4.9.5",
    "typescript-plugin-css-modules": "5.0.1",
    "unist-util-find": "3.0.0",
    "unist-util-find-before": "4.0.0",
    "unist-util-flat-filter": "2.0.0",
    "webpack": "5.88.2",
    "yaml": "2.2.2"
  },
  "peerDependencies": {
    "react": "^17.0.0 || ^18.0.0",
    "react-dom": "^17.0.0 || ^18.0.0",
    "styled-components": "4.x || 5.x"
  },
  "prettier": "@github/prettier-config",
  "size-limit": [
    {
      "path": "dist/browser.esm.js",
      "webpack": false,
      "running": false
    },
    {
      "path": "dist/browser.umd.js",
      "webpack": false,
      "running": false
    }
  ],
  "lint-staged": {
    "**/*.{js,ts,tsx,md,mdx}": "npm run lint"
  }
}
